webpackJsonp([1],{

/***/ "+GIi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.done),expression:"done"}]},[_c('NavBar',{attrs:{"title":"Geeker"}}),_vm._v(" "),_c('div',{staticClass:"fix"},[_c('div',{staticClass:"wave"}),_vm._v(" "),_c('h1',{staticStyle:{"position":"absolute","top":"100px","text-align":"center","color":"white","width":"100%"}},[_vm._v("Having Tech Issues?\n        "),_c('p',{staticStyle:{"position":"relative","color":"#bdbdbd","font-size":"15pt","padding-top":"10px"}},[_vm._v("\n          Describe your issue below and get support fast!\n        ")])]),_vm._v(" "),_c('b-container',[_c('TicketForm',{staticStyle:{"position":"relative","top":"-100px"},on:{"createnewticket":function($event){_vm.createTicket($event)}}})],1)],1),_vm._v(" "),_c('TicketList',{attrs:{"tickets":_vm.tickets},on:{"closeTickets":function($event){_vm.closeTicket($event)},"createServiceNow":function($event){_vm.serviceNow($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/aLK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2j3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NavBar_NavBar__ = __webpack_require__("KSWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TicketList_TicketList_vue__ = __webpack_require__("6epO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Form_TicketForm_vue__ = __webpack_require__("C70V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebaseInit__ = __webpack_require__("qVsQ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  components: { TicketList: __WEBPACK_IMPORTED_MODULE_3__components_TicketList_TicketList_vue__["a" /* default */], TicketForm: __WEBPACK_IMPORTED_MODULE_4__components_Form_TicketForm_vue__["a" /* default */], NavBar: __WEBPACK_IMPORTED_MODULE_2__components_NavBar_NavBar__["a" /* default */] },
  data: function data() {
    return {
      done: false,
      tickets: []
    };
  },
  firestore: function firestore() {
    return {
      tickets: __WEBPACK_IMPORTED_MODULE_5__firebaseInit__["a" /* default */].collection("tickets").orderBy("createdAt")
    };
  },

  methods: {
    createTicket: function createTicket(Description) {
      __WEBPACK_IMPORTED_MODULE_5__firebaseInit__["a" /* default */].collection("tickets").add({
        description: Description,
        name: localStorage.getItem("name"),
        user: localStorage.getItem("user"),
        createdAt: new Date(),
        chat: [{
          user: "Blake Mastrud",
          message: "Try Restart!",
          createdAt: new Date()
        }, { user: "Cindy Wilson", message: "Ok thanks ", createdAt: new Date() }]
      });
    },
    closeTicket: function closeTicket(id) {
      // <-- and here
      __WEBPACK_IMPORTED_MODULE_5__firebaseInit__["a" /* default */].collection("tickets").doc(id).delete().then(function (data) {
        console.log("Ticket Deleted Successfully");
      }).catch(function (err) {
        return console.log(err);
      });
    },
    serviceNow: function serviceNow(info) {
      var ticketInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        short_description: "Testing!!!!!!!!!!!!!",
        assigned_to: "bmastrud",
        assignment_group: "ConsumerServices_Tier2",
        caller_id: "cwilson2",
        password: info.password,
        comments: "Ticket Created By GetAGeek\n Affected User: test \n Responsible Tech: bmastrud",
        cmTickets_ci: ""
      });
    }
  },
  mounted: function mounted() {
    this.done = true;
  }
});

/***/ }),

/***/ "6epO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketList_vue__ = __webpack_require__("7jlz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e609f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketList_vue__ = __webpack_require__("PTAe");
function injectStyle (ssrContext) {
  __webpack_require__("ZUdl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05e609f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e609f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7G8Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiKey: "AIzaSyByibiqknvAevtxg97-j0jkegYYv_C0cic",
  authDomain: "getageek-d55a6.firebaseapp.com",
  databaseURL: "https://getageek-d55a6.firebaseio.com",
  projectId: "getageek-d55a6",
  storageBucket: "getageek-d55a6.appspot.com",
  messagingSenderId: "893615274260"
});

/***/ }),

/***/ "7gCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navvy-normal fixed-top",class:{ 'navvy': _vm.navbarWatcher },attrs:{"id":"navbar"}},[_c('b-navbar',{attrs:{"toggleable":"md","type":"dark"}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{attrs:{"href":"#"}},[_c('p',{staticClass:"icon"},[_c('img',{attrs:{"src":__webpack_require__("Y5cW"),"width":"250"}})])]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',[_c('span',{staticStyle:{"color":"white"}},[_vm._v("Welcome, "+_vm._s(_vm.LoggedInUser))])]),_vm._v(" "),_c('b-nav-item',[_c('span',{staticClass:"red",on:{"click":_vm.logout}},[_vm._v("Logout")])])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"registrationModal",attrs:{"hide-footer":"","title":"Please enter your username and PC Asset Number"},model:{value:(_vm.registered),callback:function ($$v) {_vm.registered=$$v},expression:"registered"}},[_c('div',{staticClass:"d-block text-center"},[_c('b-input-group',{staticClass:"mb-2",attrs:{"prepend":"name"}},[_c('b-form-input',{ref:"name"})],1),_vm._v(" "),_c('b-input-group',{staticClass:"mb-2",attrs:{"prepend":"Username"}},[_c('b-form-input',{ref:"username"})],1),_vm._v(" "),_c('b-input-group',{attrs:{"prepend":"PC Asset Number?"}},[_c('b-form-input',{ref:"asset"})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7jlz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Ticket_List",
  components: {},
  props: { tickets: {} },
  data: function data() {
    return { password: "" };
  },


  methods: {
    dateFormat: function dateFormat(seconds) {
      var date = new Date(0);
      date.setUTCSeconds(seconds);
      return date.toDateString();
    }
  }
});

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C70V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketForm_vue__ = __webpack_require__("jkKw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0d79c0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketForm_vue__ = __webpack_require__("hb0G");
function injectStyle (ssrContext) {
  __webpack_require__("j8IN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0d79c0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0d79c0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4061c7f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("aTJ6");
function injectStyle (ssrContext) {
  __webpack_require__("PbbD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4061c7f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GfHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KSWh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__ = __webpack_require__("rCNp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10aee08a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__ = __webpack_require__("7gCD");
function injectStyle (ssrContext) {
  __webpack_require__("/aLK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10aee08a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10aee08a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fadbfde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Xh86");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fadbfde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__("dih4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire__ = __webpack_require__("hnaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuefire__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].component("icon", __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */]);
/* eslint-disable no-new */
var app = void 0;
__WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.auth().onAuthStateChanged(function (user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */]({
      el: '#app',
      router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
      template: '<App/>',
      components: {
        App: __WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */]
      }
    });
  }
});

/***/ }),

/***/ "PEyl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("2j3j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cb04397_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("+GIi");
function injectStyle (ssrContext) {
  __webpack_require__("tR+R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cb04397"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cb04397_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PTAe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pad"},[_c('transition-group',{attrs:{"name":"list","mode":"out-in"}},_vm._l((_vm.tickets),function(ticket){return _c('div',{key:ticket.id,staticClass:"list-group"},[_c('div',{staticClass:"container "},[_c('b-card',{staticClass:"hover"},[_c('div',[_c('b-badge',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.dateFormat(ticket.createdAt.seconds))+" ")])],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(ticket.name)+" ")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("\n            "+_vm._s(ticket.description)+"\n            ")]),_vm._l((ticket.chat),function(details){return _c('div',{key:details.index},[_vm._v("\n\n              "+_vm._s(details.user)+" - "+_vm._s(details.message)+"\n\n            ")])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(ticket.id),expression:"ticket.id"}],staticClass:"closeButton red-background",attrs:{"variant":"danger"}},[_c('icon',{attrs:{"name":"times","scale":"1.8"}})],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal",value:(ticket.id + 1),expression:"ticket.id + 1"}],staticClass:"snTicketInit blue-background",attrs:{"variant":"primary"}},[_c('icon',{attrs:{"name":"ticket","scale":"1.8"}})],1)],2)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":ticket.id,"size":"sm ","ok-title":"Close ","title":"Close Ticket "},on:{"ok":function($event){_vm.$emit('closeTickets', ticket.id)}}},[_c('p',{staticClass:"my-4 "},[_vm._v("Are you sure you want to close ticket?")])]),_vm._v(" "),_c('b-modal',{attrs:{"id":ticket.id + 1,"size":"sm ","ok-title":"Create SN Incident ","title":"Create Incident "},on:{"ok":function($event){_vm.$emit('createServiceNow', {id: ticket.id, description: ticket.description, name: ticket.name, password: _vm.password})}}},[_c('p',{staticClass:"my-4 "},[_vm._v("Are you sure you want to create a Service-Now Incident?")]),_vm._v(" "),_c('label',{attrs:{"for":"pass"}},[_c('h3',[_vm._v("Enter Password")])]),_vm._v(" "),_c('b-input',{attrs:{"id":"pass"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PbbD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xh86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y5cW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/GetAGeekLogo.371fa9a.png";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Views_Home__ = __webpack_require__("PEyl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__("dih4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__("/ocq");







__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_1__components_Views_Home__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_0__components_Login__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }]
});

router.beforeEach(function (to, from, next) {
  // Check for requiresAuth guard
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // Check if NO logged user
    if (!__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser) {
      // Go to login
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else if (to.matched.some(function (record) {
    return record.meta.requiresGuest;
  })) {
    // Check if NO logged user
    if (__WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser) {
      // Go to login
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else {
    // Proceed to route
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZUdl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aTJ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "hb0G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{staticClass:"input-group ",staticStyle:{"z-index":"1"}},[_c('b-input-group',{attrs:{"size":"sm","prepend":"Problem"}},[_c('b-form-textarea',{attrs:{"id":"textarea1","rows":3,"max-rows":3},model:{value:(_vm.ticketForm.description),callback:function ($$v) {_vm.$set(_vm.ticketForm, "description", $$v)},expression:"ticketForm.description"}}),_vm._v(" "),_c('b-btn',{staticClass:"submitButton blue-background",on:{"click":_vm.submitForm}},[_c('icon',{attrs:{"name":"paper-plane","scale":"1.8"}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j8IN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jkKw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Ticket_Form",
  props: {},
  data: function data() {
    return { ticketForm: { description: "" } };
  },

  methods: {
    submitForm: function submitForm() {
      this.$emit("createnewticket", this.ticketForm.description);
      this.ticketForm.description = "";
    }
  },
  created: function created() {},
  destroyed: function destroyed() {}
});

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__("dih4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "login",
  data: function data() {
    return {
      email: "",
      password: "",
      LoginProgress: false,
      loginErr: "",
      showErr: false,
      modalSwitch: ""
    };
  },
  methods: {
    registerPage: function registerPage(e) {
      if (this.modalSwitch == "Login") {
        this.modalSwitch = "Sign Up";
        e.preventDefault();
      } else {
        this.modalSwitch = "Login";
        e.preventDefault();
      }
    },
    register: function register(e) {
      e.preventDefault();
    },
    login: function login(e) {
      var _this = this;

      this.LoginProgress = !this.LoginProgress;
      __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
        _this.$router.push({ location: "/" });
      }, function (err) {
        e.preventDefault();
        _this.LoginProgress = !_this.LoginProgress;
        _this.loginErr = err.message;
        _this.showErr = true;
        setTimeout(function () {
          _this.showErr = false;
        }, 300);
      });
      e.preventDefault();
    }
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      this.modalSwitch = "Login";
    });
  }
});

/***/ }),

/***/ "qVsQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__("881v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebaseConfig__ = __webpack_require__("7G8Q");



var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_2__firebaseConfig__["a" /* default */]);
var firestore = firebaseApp.firestore();

var settings = { /* your settings... */
  timestampsInSnapshots: true
};
firestore.settings(settings);

firestore.enablePersistence();
/* harmony default export */ __webpack_exports__["a"] = (firestore);

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r/dM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerr"},[_c('span',{staticClass:"Swap",on:{"click":_vm.registerPage}},[_vm._v(_vm._s(_vm.modalSwitch == 'Login' ? 'Sign Up' : 'Login'))]),_vm._v(" "),_c('transition',{attrs:{"name":"slideLeft"}},[(_vm.modalSwitch == 'Login')?_c('form',{staticClass:"login"},[_c('div',{staticClass:"AppName"},[_c('img',{attrs:{"src":__webpack_require__("Y5cW"),"width":"280"}})]),_vm._v(" "),_c('div',{staticClass:"login_fields"},[_c('div',{staticClass:"login_fields__user"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"placeholder":"Email","type":"email","autocomplete":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"login_fields__password"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"placeholder":"Password","id":"LoginpasswordField","type":"password","autocomplete":"current-password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"forgot"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Forgotten password?")])]),_vm._v(" "),_c('div',{staticClass:"login_fields__submit"},[_c('button',{class:{ 'loginButton': true, 'loading': _vm.LoginProgress, 'err': _vm.showErr },attrs:{"id":"loginButton"},on:{"click":_vm.login}},[(!_vm.LoginProgress)?_c('span',[_vm._v("Login")]):_vm._e(),_vm._v(" "),(_vm.LoginProgress)?_c('span',{staticClass:"spinner"}):_vm._e()])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"slideRight"}},[(_vm.modalSwitch == 'Sign Up')?_c('form',{key:"register",staticClass:"registerForm"},[_c('div',{staticClass:"AppName"},[_c('img',{attrs:{"src":__webpack_require__("Y5cW"),"width":"280"}})]),_vm._v(" "),_c('div',{staticClass:"login_fields"},[_c('div',{staticClass:"login_fields__user"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],attrs:{"id":"registerEmail","placeholder":"Email","type":"email","autocomplete":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"login_fields__password"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"placeholder":"Password","id":"RegisterpasswordField","type":"password","autocomplete":"current-password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"login_fields__submit"},[_c('button',{staticClass:"regButton",on:{"click":_vm.register}},[_vm._v("Sign Up")])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rCNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__("yviF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__("dih4");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NavBar",
  props: { title: "", user: "" },
  data: function data() {
    return {
      //Change navbar class if scroll > 200
      registered: false,
      navbarWatcher: false
    };
  },

  computed: {
    LoggedInUser: function LoggedInUser() {
      return __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().currentUser.email;
    }
  },

  methods: {
    scrollWatcher: function scrollWatcher() {
      this.navbarWatcher = document.documentElement.scrollTop > 100 || document.body.scrollTop > 100; //THis is for Mobile
    },

    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().signOut().then(function () {
        _this.$router.push({ location: "/login" });
      });
    }
  },
  created: function created() {
    window.addEventListener("scroll", this.scrollWatcher, { passive: true });
  },
  destroyed: function destroyed() {
    window.removeEventListener("scroll", this.scrollWatcher, { passive: true });
  }
});

/***/ }),

/***/ "tR+R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uPme":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index_js__ = __webpack_require__("YaEn");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  components: { router: __WEBPACK_IMPORTED_MODULE_0__router_index_js__["a" /* default */] }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e17f45d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("r/dM");
function injectStyle (ssrContext) {
  __webpack_require__("uPme")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e17f45d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e17f45d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6f230d82dd4da0cd1e87.js